import { useSelector } from "react-redux";
import { getAuthClaims } from "@redriver/cinnamon";
import { UserArea, UserType } from "features/../../../shared/constants/enums";

const useCurrentUser = () => {
  const { userId, userName, userEmail, userType, userArea, companyId } =
    useSelector(getAuthClaims);
  const isInternalUser = userType == UserType.HQ;

  return {
    id: userId,
    name: userName,
    email: userEmail,
    userType,
    userArea,
    companyId,
    isInternalUser,
    isSupplierAdminUser:
      userType === UserType.Dealer && userArea === UserArea.SupplierAdmin,
    isAccountManagerUser:
      userType === UserType.Dealer && userArea == UserArea.AccountManager,
    isSalesAdminUser:
      userType === UserType.Dealer && userArea == UserArea.SalesAdmin,
    isSalesManagerUser:
      userType === UserType.Dealer && userArea == UserArea.SalesManager,
  };
};

export default useCurrentUser;
